import React from 'react';
import './style.scss';
import RollingLane from '../../rollingLane';
import LoadableImage from '../../../../general/loadableImage';
import LandingMintSectionNft from './nft';
import { PromoProvider } from '../../../marketPage/promoCode/Context';

const LandingMintSection = () => {
  return (
    <>
      <RollingLane id='nft' text='GET YOUR HAND' />
      <section id='mint' className='landing-mint-section'>
        <div className='landing-mint-section-content'>
          <div className='lmis-content-desc'>
            <div className='lmis-content-desc-ph' />
            <div className='lmis-content-desc-content'>
              <div className='lmis-content-desc-wording'>
                <h2>mint</h2>
                <h4>and</h4>
                <h2>play</h2>
              </div>
              <p className='lmis-content-desc-text body-1'>
                Mint your NFT Nifty Hand and start fighting to earn now.
                <br />
                <br />
                Nifty Hands are extremely violent but loyal to their masters
                non-fungible creatures. They fight against each other in crypto
                version of rock, paper, scissors.
                <br />
                <br />
                There are three major clans: rock-omoto, paper-ashI and
                scissors-inu. Each clan is extremely skilful in their fighting
                styles.
                <br />
                <br />
                Pick your clan wisely. This will be important in pro battles.
              </p>
            </div>
          </div>
          <PromoProvider>
            <LandingMintSectionNft />
          </PromoProvider>
        </div>
        <LoadableImage
          src='../../../assets/images/market/bg_hands.png'
          className='lmis-background'
        />
      </section>
      <RollingLane text='GET YOUR HAND' />
    </>
  );
};

export default LandingMintSection;
